module.exports = __webpack_public_path__ + "static/media/Hasneky.19ac6cba.md";